import axios from 'axios'
import { Toast } from 'vant';
import Vue from 'vue'
import vueCookies from 'vue-cookies'
import configUrl from '@/libs/config'
import uniondrug from 'uniondrug';

//http 相应 拦截器
axios.interceptors.response.use(response => {
    Vue.$loading.hide();
    if (response.data.errno === '0') {
        return response;
    } else if (response.data.errno === '401' || response.data.errno === '403') {
        // 药店宝打开
        if (sessionStorage.getItem('state') == 'ydb') {
            // 三个环境
            vueCookies.set("union_token", '', -1, '/', configUrl.config().domin);
            // 本地环境
            vueCookies.set("union_token", '', -1, '/', 'localhost');
            let firstUrlQuery = JSON.parse(sessionStorage.getItem('firstUrlQuery'))
            let redirect_uri = window.location.href + '?token=' + firstUrlQuery.token + "&loginType=" + firstUrlQuery.loginType
            window.location.replace(redirect_uri)
        } else {
            console.log('configUrl',configUrl,configUrl.config())
            // 微信打开
            vueCookies.set("union_token", '', -1, '/', configUrl.config().domin);
            let redirect_uri = encodeURIComponent(window.location.href);
            window.location.replace(configUrl.config().auth + '/authority?redirect_uri=' + redirect_uri)
        }
    } else {
        return response;
    }
},
    error => {
        return Promise.reject(error)
    }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}, type) {
    Vue.$loading.show();
    axios.defaults.timeout = 300000;
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    axios.defaults.baseURL = configUrl.config().host;
    const token = uniondrug.getToken() // vueCookies.get('union_token');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                const data = response.data;
                if (data.errno === '0' || response.status == 200) {
                    resolve(data);
                } else {
                    resolve(data);
                }
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data, type) {
    Vue.$loading.show();
    axios.defaults.timeout = 300000;
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    axios.defaults.baseURL = configUrl.config().host;
    const union_token = uniondrug.getToken(); //vueCookies.get('union_token');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + union_token;
    return new Promise((resolve, reject) => {
        axios.post(url, data, type)
            .then(response => {
                const data = response.data;
                if (data.errno === '0') {
                    resolve(data);
                } else {
                    if (type !== '1') {
                        if (/[a-zA-Z]/.test(response.data.error)) {
                            Toast('网络问题，请稍后再试');
                        } else {
                            Toast(response.data.error);
                        }
                    } else {
                        resolve(data);
                    }
                }
            }, err => {
                reject(err)
            })
    })
}



/**
 * 封装upload上传文件请求
 * @param url
 * @param files
 * @returns {Promise}
 */
export function upload(url, files) {
    Vue.$loading.show();
    axios.defaults.baseURL = configUrl.config().host;
    const union_token = uniondrug.getToken() //vueCookies.get('union_token');
    axios.defaults.headers.post['Authorization'] = 'Bearer ' + token;
    let params = new FormData(); //创建form对象
    params.append("file", files.file); //通过append向form对象添加数据//第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
    let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
    };  //添加请求头
    return new Promise((resolve, reject) => {
        axios.post(configUrl.config().host + url, params, config)
            .then(res => {
                resolve(res.data.data)
            }, err => {
                reject(err)
            })
    })
}


